import { render, staticRenderFns } from "./ContractServicesTable.vue?vue&type=template&id=8dd050b2&"
import script from "./ContractServicesTable.vue?vue&type=script&lang=js&"
export * from "./ContractServicesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports